<!-- Created by init-app.js at Tue Mar 10 2020 16:02:41 GMT+0100 (GMT+01:00) -->
<template>
  <v-app id="wgu-app" data-app :class="{ 'wgu-app': true, 'wgu-app-embedded': isEmbedded }">
    <router-view></router-view>
    <notifications class="centered-notifications" :width="400" />
  </v-app>
</template>

<script>
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

export default {
  name: 'my-wgu-app',
  data () {
    return {
      isEmbedded: false
    }
  },
  created () {
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);
      const jwtExpire = decoded.exp * 1000;

      if (!jwtExpire) {
        this.$store.dispatch('logout');
        if (this.$route.path !== '/login') {
          this.$router.push('/login');
        }
        return;
      }

      if (jwtExpire < Date.now()) {
        this.$store.dispatch('logout');
        if (this.$route.path !== '/login') {
          this.$router.push('/login');
        }
      } else {
        axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;
        this.user = decoded;
        // 设置用户角色到store中
        if (decoded.role) {
          this.$store.commit('setUserRole', decoded.role);
          // 根据角色重定向到对应的页面
          if (decoded.role === 'admin' && this.$route.path === '/') {
            this.$router.push('/admin').catch(() => { });
          } else if (this.$route.path === '/') {
            this.$router.push('/ins').catch(() => { });
          }
        }
      }
    } else {
      this.$store.dispatch('logout');
      if (this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    }
  }
}
</script>

<style scoped>
.centered-notifications {
  left: 50%;
  top: 4em !important;
  transform: translate(-50%, -50%);
}
</style>
